import { Component, inject, Injector } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { Toast } from 'primeng/toast';
import { FuseSplashScreenService, InjectorHelper } from '@olymp/shared';
import { ConfirmDialog } from 'primeng/confirmdialog';

@Component({
  imports: [CommonModule, RouterOutlet, Toast, ConfirmDialog],
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.less',
})
export class App {
  injector = inject(Injector);

  private _splashScreenService = inject(FuseSplashScreenService);

  constructor() {
    InjectorHelper.injector = this.injector;
  }
  protected title = 'user';
}
